import { render, staticRenderFns } from "./chinaSearch.vue?vue&type=template&id=35155fa2&scoped=true&"
import script from "./chinaSearch.vue?vue&type=script&lang=js&"
export * from "./chinaSearch.vue?vue&type=script&lang=js&"
import style0 from "./chinaSearch.vue?vue&type=style&index=0&id=35155fa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35155fa2",
  null
  
)

export default component.exports